/** Junta handlers: chama todos, na ordem, com os mesmos argumentos (o interno do componente e o da tela, sem um apagar o outro). */
export function callAll<Args extends unknown[]>(
  ...handlers: (((...args: Args) => void) | undefined)[]
): (...args: Args) => void {
  return (...args) => {
    for (const handler of handlers) handler?.(...args);
  };
}
